// First-choice modal shown once per session after login. Lets the customer
// pick between the two big lanes ("مطاعم" vs "متاجر ومحلات") to filter the
// shop grid. Choice is stored in sessionStorage; user can change it later
// via the icon grid on the shops page.
import { UtensilsCrossed, ShoppingBag, X } from "lucide-react";

const LS_KEY = "talabya:home-lane";

export function loadLane() {
  try { return sessionStorage.getItem(LS_KEY) || null; } catch { return null; }
}
export function saveLane(lane) {
  try {
    if (lane) sessionStorage.setItem(LS_KEY, lane);
    else sessionStorage.removeItem(LS_KEY);
  } catch { /* noop */ }
}

/**
 * onPick("restaurants" | "shops" | "all")
 */
export default function CategoryPicker({ onPick, onClose }) {
  const pick = (lane) => { saveLane(lane); onPick(lane); };
  return (
    <div className="fixed inset-0 z-[80] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
         data-testid="category-picker">
      <div className="relative bg-white rounded-3xl w-full max-w-lg p-6 sm:p-8 talabya-shadow-float">
        {onClose && (
          <button onClick={onClose}
            className="absolute top-3 left-3 w-9 h-9 rounded-full bg-[var(--surface-alt)] hover:bg-red-50 hover:text-red-600 text-[var(--text-secondary)] flex items-center justify-center"
            data-testid="category-picker-close">
            <X size={16}/>
          </button>
        )}
        <div className="text-center mb-5">
          <div className="inline-block w-14 h-14 rounded-2xl bg-primary-brand text-white flex items-center justify-center mb-3 mx-auto talabya-shadow-soft">
            <ShoppingBag size={26}/>
          </div>
          <h2 className="text-2xl sm:text-3xl font-black mb-1" style={{fontFamily:"Cairo"}}>وش تبي اليوم؟</h2>
          <p className="text-sm text-[var(--text-secondary)]">اختر تصنيفاً للانطلاق — تقدر تغيّره لاحقاً من أعلى الصفحة</p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <button
            onClick={() => pick("restaurants")}
            className="group relative rounded-3xl border-2 border-[var(--border)] hover:border-primary-brand bg-white p-5 flex flex-col items-center gap-3 transition-all hover:-translate-y-1 talabya-shadow-soft"
            data-testid="lane-restaurants"
          >
            <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-orange-400 to-red-500 text-white flex items-center justify-center group-hover:scale-110 transition-transform">
              <UtensilsCrossed size={38}/>
            </div>
            <div className="text-center">
              <div className="font-black text-lg" style={{fontFamily:"Cairo"}}>المطاعم</div>
              <div className="text-[11px] text-[var(--text-secondary)] mt-0.5">مأكولات · وجبات · حلويات</div>
            </div>
          </button>

          <button
            onClick={() => pick("shops")}
            className="group relative rounded-3xl border-2 border-[var(--border)] hover:border-primary-brand bg-white p-5 flex flex-col items-center gap-3 transition-all hover:-translate-y-1 talabya-shadow-soft"
            data-testid="lane-shops"
          >
            <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-blue-500 to-emerald-500 text-white flex items-center justify-center group-hover:scale-110 transition-transform">
              <ShoppingBag size={38}/>
            </div>
            <div className="text-center">
              <div className="font-black text-lg" style={{fontFamily:"Cairo"}}>متاجر ومحلات</div>
              <div className="text-[11px] text-[var(--text-secondary)] mt-0.5">صيدليات · مواد غذائية · هواتف</div>
            </div>
          </button>
        </div>

        <button onClick={() => pick("all")}
          className="mt-4 w-full py-2.5 text-sm font-bold text-primary-brand hover:underline"
          data-testid="lane-all">
          عرض كل المحلات مباشرة
        </button>
      </div>
    </div>
  );
}
